"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvocationValidationError = exports.UnauthorizedError = exports.NetworkError = exports.HttpError = void 0;
class HttpError extends Error {
    constructor(status, message) {
        super(message);
        this.status = status;
    }
}
exports.HttpError = HttpError;
class NetworkError extends Error {
    constructor(e) {
        super(e.message);
        this.name = e.name;
        this.stack = e.stack;
    }
}
exports.NetworkError = NetworkError;
class UnauthorizedError extends Error {
}
exports.UnauthorizedError = UnauthorizedError;
class InvocationValidationError extends Error {
    constructor(validationErrors, message) {
        super(message);
        this.errors = validationErrors;
    }
}
exports.InvocationValidationError = InvocationValidationError;
//# sourceMappingURL=index.js.map